<template>
	<div class="personal_nav bg_white radius8">
		<div class="news_nav_list" v-for="item in nav" :key="item.id" :class="{'on':item.id==current.navCur}">
			<div class="news_nav_list_title flex f20px cl_dark" @click="navCheck(item.id)">
				<div class="news_nav_list_title_l flex">
					<img :src="item.icon" class="mar10" />
					<span>{{item.name}}</span>
				</div>
				<img src="../../static/select_btm.png" class="news_nav_list_title_r" />
			</div>
			<ul class="news_nav_list_cont f18px cl_gray">
				<li class="news_nav_list_item" v-for="item in item.senior_info_two_cate" :key="item.id" :class="{'on':item.id==current.listCur}"><router-link :to="item.url" class="block">{{item.name}}</router-link></li>
			</ul>
		</div>
	</div>
</template>

<script>
	export default {
	  name: 'personal_nav',
	  props: {
			current: {
				navCur: Number,
				listCur: Number,
			},
	  },
		data () {
			return {
				nav: [
					{
						id: 1,
						icon: require("../../static/icon_personal.png"),
						name: "个人中心",
						senior_info_two_cate: [
							{
								id: 1,
								name: "基础资料",
								url: "/personal",
							},{
								id: 2,
								name: "账号保护",
								url: "/personal_protect",
							},
						],
					},{
						id: 2,
						icon: require("../../static/icon_order.png"),
						name: "我的订单",
						senior_info_two_cate: [
							{
								id: 3,
								name: "我的订单",
								url: "/order",
							},{
								id: 4,
								name: "充值中心",
								url: "/payment",
							},
						],
					},
				],
				
			}
		},
		mounted() {
			
		},
		created() {
			
		},
		methods: {
			navCheck (e) {
				if (this.current.navCur == e) {
					this.current.navCur = "";
				} else {
					this.current.navCur = e;
				}
			},
		},
	}
</script>

<style>
</style>
